import React from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Input,
} from "reactstrap";
import SimpleBar from 'simplebar-react';
import user from "../../assets/images/users/user-2.jpg";
import user2 from "../../assets/images/users/user-2.jpg";
import user3 from "../../assets/images/users/user-3.jpg";
import smimg1 from "../../assets/images/small/img-1.jpg";
import smimg2 from "../../assets/images/small/img-2.jpg";

const AccountantConnect = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Row className="mb-4">
                        <Col>
                            <Card className="text-center">
                                <CardBody>
                                    <img
                                        src={user}
                                        alt="Accountant"
                                        className="img-fluid rounded-circle"
                                        style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                    />
                                </CardBody>
                                <CardBody>
                                    <h4 className="font-weight-bold">Joe Doe</h4>
                                    <p className="text-muted">
                                        Accountant at <span className="font-weight-semibold">Accountants and Bookkeepers Co.</span>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col md="6">
                            <Card>
                                <CardBody>
                                    <h5 className="font-weight-semibold">To Do for Accountant</h5>
                                    <ul className="list-unstyled">
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="task1" className="me-2" />
                                            <label htmlFor="task1" className="mb-0">Task 1</label>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="task2" className="me-2" />
                                            <label htmlFor="task2" className="mb-0">Task 2</label>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="task3" className="me-2" />
                                            <label htmlFor="task3" className="mb-0">Task 3</label>
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col md="6">
                            <Card>
                                <CardBody>
                                    <h5 className="font-weight-semibold">To Do  for Accountants and Bookkeepers Co</h5>
                                    <ul className="list-unstyled">
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="taskA" className="me-2" />
                                            <label htmlFor="taskA" className="mb-0">Task A</label>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="taskB" className="me-2" />
                                            <label htmlFor="taskB" className="mb-0">Task B</label>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <input type="checkbox" id="taskC" className="me-2" />
                                            <label htmlFor="taskC" className="mb-0">Task C</label>
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col md="6">
                            <Card className="shadow-lg border-0">
                                <CardBody>
                                    <h5 className="font-weight-semibold">File Receive</h5>
                                    <div className="d-flex justify-content-between align-items-center p-2 rounded bg-light shadow-sm">
                                        <span className="text-danger fw-bold d-flex align-items-center">
                                            <i className="fas fa-exclamation-circle me-2"></i> Files Awaiting Signature
                                        </span>
                                        <span className="badge bg-danger rounded-pill fs-6 px-3 py-2 animate-bounce">5</span>
                                    </div>
                                    <div className="mt-3">
                                        <h6 className="text-primary">Received Files:</h6>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            <ul className="list-unstyled">
                                                {['DemoFile1.pdf', 'DemoFile2.txt', 'DemoFile3.jpg', 'DemoFile4.pdf', 'DemoFile5.txt', 'DemoFile6.jpg', 'DemoFile7.pdf', 'DemoFile8.txt', 'DemoFile9.jpg', 'DemoFile10.pdf', 'DemoFile11.txt', 'DemoFile12.jpg', 'DemoFile13.pdf', 'DemoFile14.txt', 'DemoFile15.jpg'].map((file, index) => (
                                                    <li key={index} className="d-flex justify-content-between align-items-center p-2 border-bottom">
                                                        <span className="text-muted">{file}</span>
                                                        <Button color="primary" size="sm" className="fw-bold">Open</Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>





                        <Col md="6">
                            <Card>
                                <CardBody>
                                    <h5 className="font-weight-semibold">File Send</h5>

                                    {/* Send File Button */}
                                    <Button color="success" className="w-100 mb-3">Send File</Button>

                                    {/* Drag and Drop Area */}
                                    <div
                                        className="border border-dashed p-4 text-center"
                                        style={{ cursor: 'pointer', borderRadius: '8px' }}
                                    >
                                        <h6>Drag and Drop Your Files Here</h6>
                                        <p>Or</p>
                                        <input
                                            type="file"
                                            className="d-none"
                                            id="fileInput"
                                            onChange={(e) => alert('File Selected: ' + e.target.files[0].name)}
                                        />
                                        <label htmlFor="fileInput" className="btn btn-primary">
                                            Select Files
                                        </label>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>

                    <Row>
                        <Col>
                            <Card className="shadow-lg border-0">
                                <CardBody>
                                    <h4 className="card-title mb-4">Chat</h4>

                                    <div className="chat-conversation">
                                        <SimpleBar style={{ height: "365px" }}>
                                            <ul className="conversation-list" style={{ maxHeight: "367px" }}>

                                                {/* Joe Message */}
                                                <li className="clearfix">
                                                    <div className="chat-avatar">
                                                        <img src={user2} className="avatar-xs rounded-circle" alt="male" />
                                                        <span className="time">10:00</span>
                                                    </div>
                                                    <div className="conversation-text">
                                                        <div className="ctext-wrap">
                                                            <span className="user-name">Joe Deo</span>
                                                            <p>Hello! 😊</p>
                                                        </div>
                                                    </div>
                                                </li>

                                                {/* Smith Message */}
                                                <li className="clearfix odd">
                                                    <div className="chat-avatar">
                                                        <img src={user3} className="avatar-xs rounded-circle" alt="female" />
                                                        <span className="time">10:01</span>
                                                    </div>
                                                    <div className="conversation-text">
                                                        <div className="ctext-wrap">
                                                            <span className="user-name">Smith</span>
                                                            <p>Hi, How are you? What about our next meeting? 🤔</p>
                                                        </div>
                                                    </div>
                                                </li>

                                                {/* Joe Message */}
                                                <li className="clearfix">
                                                    <div className="chat-avatar">
                                                        <img src={user2} className="avatar-xs rounded-circle" alt="male" />
                                                        <span className="time">10:04</span>
                                                    </div>
                                                    <div className="conversation-text">
                                                        <div className="ctext-wrap">
                                                            <span className="user-name">Joe Deo</span>
                                                            <p>Yeah, everything is fine. 👍</p>
                                                        </div>
                                                    </div>
                                                </li>

                                                {/* Smith Sending Files */}
                                                <li className="clearfix odd">
                                                    <div className="chat-avatar">
                                                        <img src={user3} className="avatar-xs rounded-circle" alt="male" />
                                                        <span className="time">10:08</span>
                                                    </div>
                                                    <div className="conversation-text">
                                                        <div className="ctext-wrap">
                                                            <span className="user-name mb-2">Smith</span>
                                                            <p>Here are the documents 📂</p>
                                                            <div className="mt-2">
                                                                <a href="https://example.com/file1.pdf" download className="text-primary">
                                                                    <i className="fas fa-file-pdf"></i> File1.pdf
                                                                </a>
                                                                <br />
                                                                <a href="https://example.com/image1.jpg" download className="text-primary">
                                                                    <i className="fas fa-file-image"></i> Image1.jpg
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                {/* Smith Sending Images */}
                                                <li className="clearfix odd">
                                                    <div className="chat-avatar">
                                                        <img src={user3} className="avatar-xs rounded-circle" alt="male" />
                                                        <span className="time">10:08</span>
                                                    </div>
                                                    <div className="conversation-text">
                                                        <div className="ctext-wrap">
                                                            <span className="user-name mb-2">Smith</span>
                                                            <img src={smimg1} alt="Attachment" height="48" className="rounded me-2" />
                                                            <img src={smimg2} alt="Attachment" height="48" className="rounded" />
                                                        </div>
                                                    </div>
                                                </li>

                                            </ul>
                                        </SimpleBar>

                                        {/* Chat Input */}
                                        <Row className="mt-3 pt-1">
                                            <Col md="8" className="chat-inputbar col-7">
                                                <Input type="text" className="chat-input" placeholder="Enter your text ✍️" />
                                            </Col>
                                            <Col md="2" className="chat-emoji col-2">
                                                <Button color="warning" className="w-100">
                                                    😊
                                                </Button>
                                            </Col>
                                            <Col md="2" className="chat-send col-3">
                                                <Button type="submit" color="success" className="w-100">
                                                    Send 🚀
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AccountantConnect;
